import { Grid, Skeleton } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { useApiQuery } from "../../../../../../../core/api/useApiQuery"
import { fetchUserMeetingService, FetchUserMeetingServiceResponse, UserWeekMenu } from "../../../weekMenuApi"
import { useAppSelector } from "../../../../../../store/storeHooks"
import { selectUserId } from "../../../../../../login/loginSelectors"
import { RefetchIntervals } from "../../../../../../../core/api/refetchIntervals"
import { DatePeriod } from "../../../../../../../shared/components/filters/selectDatePeriodFilter/SelectDatePeriodFilter"

import { MeetingsPanel } from "./MeetingsPanel"

const useStyles = makeStyles()(() => ({
    column: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
    },
    skeletonCard: {
        height: "20rem",
        borderRadius: "1rem",
    },
}))

const transform = (data: FetchUserMeetingServiceResponse) => data.orders

type UserMeetingsProps = Readonly<{
    period: DatePeriod
}>

export function UserMeetings({ period }: UserMeetingsProps) {
    const { classes } = useStyles()
    const userId = useAppSelector(selectUserId)

    const { data: meetings, isLoading } = useApiQuery(fetchUserMeetingService, {
        queryName: UserWeekMenu.MEETING_SERVICE_LIST,
        dependencies: {
            userId: userId ?? 0,
            period,
            view: "dashboard",
        },
        enabled: Boolean(userId),
        select: transform,
        refetchInterval: RefetchIntervals.short,
    })

    if (isLoading) {
        return (
            <Grid item xs={12} className={classes.column}>
                <Skeleton variant="rectangular" className={classes.skeletonCard} />
            </Grid>
        )
    }

    return (
        <Grid item xs={12} className={classes.column}>
            <MeetingsPanel meetings={meetings ?? []} period={period} />
        </Grid>
    )
}
